export default __webpack_public_path__ + "static/redis-5490a610edf8986966731e04c35c4103.png";